import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import spoon from '../assets/spoon.svg';
import homeimage from '../assets/homeimage.jpg';
import phobospecial from '../assets/phobospecial.jpg';
import gallery1 from '../assets/gallery1.jpg';
import gallery2 from '../assets/gallery2.jpg';
import gallery3 from '../assets/gallery3.jpg';
import gallery4 from '../assets/gallery4.jpg';
import gallery5 from '../assets/gallery5.jpg';
import gallery6 from '../assets/gallery6.jpg';
import milkteaCategory from '../assets/milkteaCategory.jpg';
import charamCategory from '../assets/charamCategory.jpg';
import phoCategory from '../assets/phoCategory.jpg';
import riceCategory from '../assets/riceCategory.jpg';
import otherCategory from '../assets/otherCategory.jpg';
import bevergate from '../assets/beverage.jpg';
import familysize from '../assets/familysize.jpg';
import friedrice from '../assets/friedrice.jpg';
import riceplate from '../assets/riceplate.jpg';
import friednoodle from '../assets/stir-friednoodle.jpg';
import springroll from '../assets/springroll.jpg';
import noodlesoup from '../assets/noodlesoup.jpg';
import ricevermicellibowl from '../assets/ricevermicellibowl.jpg';
import appetizer from '../assets/appetizer.jpg';

export default {
  bg,
  logo,
  spoon,
  homeimage,
  phobospecial,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  milkteaCategory,
  charamCategory,
  phoCategory,
  riceCategory,
  otherCategory,
  bevergate,
  familysize,
  friedrice,
  riceplate,
  friednoodle,
  springroll,
  noodlesoup,
  ricevermicellibowl,
  appetizer,
};
